// extracted by mini-css-extract-plugin
export default {"menuWrapper":"R4EoTJtl64ur6c829V_1","popupClassname":"Rjt5i6etpZO_7KStrKwH"};